/* JWC Set Explode — combination-set add-to-cart -> component bottles.
 * Spec: store-ops/shopify/wine/set-explode-in-house-SPEC-2026-07-23.md
 * Covers ALL add-to-cart surfaces via a global fetch + XHR intercept on /cart/add,
 * plus a cart-reconcile safety net for permalinks / full-reload adds.
 *
 * SAFETY: PREVIEW GATE. The script is INERT unless either
 *   (a) ACTIVE_FOR_ALL === true  (flip this to go live for everyone), or
 *   (b) the visitor has seen ?set_explode=preview this session.
 * So it can be deployed to the live theme with ZERO impact on real customers,
 * tested via the preview URL, then activated by flipping ACTIVE_FOR_ALL.
 */
(function () {
  "use strict";

  var ACTIVE_FOR_ALL = true; // GO-LIVE 2026-07-23 (was false / preview-gated)

  // set VARIANT id -> { set: SKU, comps: [component variant ids] }
  var SETS = {
    48900762894592: { set: "KAZUMI-SET-750",   comps: [47587302473984, 48672311279872] },
    48901192614144: { set: "GRACE-SET-750",    comps: [48672323764480, 48672344670464] },
    48901252153600: { set: "WHITE-SET-750",    comps: [48672323764480, 47587302473984] },
    48901453807872: { set: "RED-SET-750",      comps: [48672344670464, 48672311279872] },
    48901550670080: { set: "JAPANESE-4SET-750", comps: [48672323764480, 48672344670464, 47587302473984, 48672311279872] }
  };

  // ---- preview gate ----
  try {
    if (new URLSearchParams(location.search).get("set_explode") === "preview") {
      sessionStorage.setItem("jwcSetExplode", "1");
    }
  } catch (e) {}
  var ACTIVE = ACTIVE_FOR_ALL || (function () {
    try { return sessionStorage.getItem("jwcSetExplode") === "1"; } catch (e) { return false; }
  })();
  if (!ACTIVE) return;

  function uuid() {
    try { return crypto.randomUUID(); } catch (e) { return "b" + Date.now() + Math.round(Math.random() * 1e6); }
  }
  function isSet(id) { return !!SETS[parseInt(id, 10)]; }

  // one set line {id, quantity, selling_plan, properties} -> component line items
  function explode(line) {
    var conf = SETS[parseInt(line.id, 10)];
    if (!conf) return null;
    var q = parseInt(line.quantity, 10) || 1;
    var bid = uuid();
    return conf.comps.map(function (cv) {
      var it = {
        id: cv,
        quantity: q,
        properties: Object.assign({}, line.properties || {}, { _bundle_id: bid, _set: conf.set })
      };
      if (line.selling_plan) it.selling_plan = line.selling_plan;
      return it;
    });
  }

  // JSON /cart/add payload -> exploded {items:[...]}, or original if no set present
  function transformJson(obj) {
    if (!obj) return obj;
    var items = obj.items ? obj.items : [obj]; // single-line vs items[] form
    var out = [], changed = false;
    items.forEach(function (it) {
      if (it && it.id != null && isSet(it.id)) {
        out = out.concat(explode({ id: it.id, quantity: it.quantity, selling_plan: it.selling_plan, properties: it.properties }));
        changed = true;
      } else { out.push(it); }
    });
    if (!changed) return obj;
    return obj.items ? Object.assign({}, obj, { items: out }) : { items: out };
  }

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  // ---- fetch intercept ----
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === "string") ? input : (input && input.url) || "";
      if (ADD_RE.test(url) && init && init.body) {
        var body = init.body;
        if (typeof body === "string") {
          var s = body.trim();
          if (s.charAt(0) === "{") {                       // JSON
            var t = transformJson(JSON.parse(body));
            init = Object.assign({}, init, { body: JSON.stringify(t) });
          } else if (s.indexOf("id=") > -1) {              // urlencoded
            var p = new URLSearchParams(body);
            if (isSet(p.get("id"))) {
              var items = explode({ id: p.get("id"), quantity: p.get("quantity"), selling_plan: p.get("selling_plan") });
              init = Object.assign({}, init, {
                headers: Object.assign({}, init.headers, { "Content-Type": "application/json" }),
                body: JSON.stringify({ items: items })
              });
            }
          }
        } else if (window.FormData && body instanceof FormData) { // FormData single-line
          var id = body.get("id");
          if (isSet(id)) {
            var it2 = explode({ id: id, quantity: body.get("quantity"), selling_plan: body.get("selling_plan") });
            init = Object.assign({}, init, {
              headers: Object.assign({}, init.headers, { "Content-Type": "application/json" }),
              body: JSON.stringify({ items: it2 })
            });
          }
        }
      }
    } catch (e) { if (window.console) console.warn("[set-explode] fetch", e); }
    return _fetch.call(this, input, init);
  };

  // ---- XHR intercept ----
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__seUrl = u; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__seUrl && ADD_RE.test(this.__seUrl) && typeof body === "string" && body.trim().charAt(0) === "{") {
        var t = transformJson(JSON.parse(body));
        body = JSON.stringify(t);
      }
    } catch (e) { if (window.console) console.warn("[set-explode] xhr", e); }
    return _send.call(this, body);
  };

  // ---- cart reconcile (safety net: /cart/add?id=SET permalinks, full-reload form posts) ----
  function reconcile() {
    _fetch.call(window, "/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = (cart.items || []).find(function (l) { return isSet(l.variant_id || l.id); });
        if (!line) return;
        var conf = SETS[parseInt(line.variant_id || line.id, 10)];
        var bid = uuid();
        var sp = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id;
        var adds = conf.comps.map(function (cv) {
          var it = { id: cv, quantity: line.quantity, properties: Object.assign({}, line.properties || {}, { _bundle_id: bid, _set: conf.set }) };
          if (sp) it.selling_plan = sp;
          return it;
        });
        _fetch.call(window, "/cart/change.js", {
          method: "POST", headers: { "Content-Type": "application/json" }, credentials: "same-origin",
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function () {
          return _fetch.call(window, "/cart/add.js", {
            method: "POST", headers: { "Content-Type": "application/json" }, credentials: "same-origin",
            body: JSON.stringify({ items: adds })
          });
        }).then(function () {
          if (/\/cart(\b|\/|$)/.test(location.pathname)) location.reload();
        });
      })
      .catch(function (e) { if (window.console) console.warn("[set-explode] reconcile", e); });
  }
  if (document.readyState !== "loading") reconcile();
  else document.addEventListener("DOMContentLoaded", reconcile);

  // ---- set PDP: hide dynamic checkout ("Buy it now") + inject transparency note ----
  var SET_NOTE = "Please note: each set ships as its individual full-size bottles, so it appears as separate bottles in your cart and order — they arrive together as your set.";
  function decorateSetPDPs() {
    try {
      document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (inp) {
        if (!isSet(inp.value)) return;
        var form = inp.closest("form");
        if (!form) return;
        // hide dynamic-checkout / Buy-it-now inside this set's product form (bypasses the cart otherwise)
        form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (el) { el.style.display = "none"; });
        // inject transparency note once, near the add-to-cart
        if (!form.querySelector(".jwc-set-note")) {
          var n = document.createElement("div");
          n.className = "jwc-set-note";
          n.style.cssText = "margin:10px 0;font-size:0.9em;line-height:1.4;opacity:0.85;";
          n.textContent = SET_NOTE;
          form.appendChild(n);
        }
      });
    } catch (e) { if (window.console) console.warn("[set-explode] pdp", e); }
  }
  if (document.readyState !== "loading") decorateSetPDPs();
  else document.addEventListener("DOMContentLoaded", decorateSetPDPs);
})();
